<template>
  <div
    class="checkbox"
    :style="{ 'flex-direction': labelStyle }"
    @keyup.enter="_handleCheckboxClick"
  >
    <div
      v-if="label"
      @click="titleClick()"
      :class="['checkbox__label', { 'checkbox__label-hover': titleHover }]"
      :style="{ color: labelColor }"
    >
      {{ label }}
    </div>
    <div
      @click.stop="_handleCheckboxClick"
      :class="[
        'checkbox__checkbox',
        { checkbox__checkbox_active: value },
        { checkbox__checkbox_disabled: disabled },
      ]"
      :style="{ border: innerBorder }"
      ref="toggle"
    >
      <svg
        v-if="disabled && !value"
        width="8"
        height="2"
        viewBox="0 0 8 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66753 1.88911H1.3342C0.843282 1.88911 0.445312 1.49114 0.445312 1.00022C0.445312 0.509297 0.843282 0.111328 1.3342 0.111328H6.66753C7.15845 0.111328 7.55642 0.509297 7.55642 1.00022C7.55642 1.49114 7.15845 1.88911 6.66753 1.88911Z"
          fill="#D9D9D9"
        />
      </svg>
      <svg
        v-else
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 3.89L3.74 6.13L8.5 1.37"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    disabled: Boolean,
    label: { default: '', type: String },
    value: { default: false, type: Boolean },
    innerBorder: { default: '', type: String },
    labelPosition: {
      default: 'right',
      type: String,
      validator: function (value) {
        return ['top', 'right', 'bottom', 'left'].indexOf(value) !== -1;
      },
    },
    labelColor: {
      default: '',
      type: String,
    },
    titleHover: {
      default: false,
      type: Boolean,
    },
  },
  emits: {
    input: null,
  },
  computed: {
    labelStyle() {
      let direction = 'column';
      switch (this.labelPosition) {
        case 'top':
          direction = 'column';
          break;
        case 'right':
          direction = 'row-reverse';
          break;
        case 'bottom':
          direction = 'column-reverse';
          break;
        case 'left':
          direction = 'row';
          break;
      }
      return direction;
    },
  },
  methods: {
    /* UI */
    _handleCheckboxClick() {
      if (this.disabled) return;

      this.$emit('input', !this.value);
    },
    /*  */
    click() {
      this.$refs.toggle.click();
    },
    titleClick() {
      this.$emit('title-click');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Checkbox';
</style>
